<template>
  <div>
    <br />
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="200"
                        :class="{ 'table-sorted': sortType == 'customer_id' }"
                        @click="sortCall('customer_id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'customer_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'customer_id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'customer_id'"></span>
                      </td>

                      <td nowrap class="text-center align-middle" width="200">ID Contrato</td>
                      <td nowrap class="text-center align-middle" width="200">Tipo Contrado</td>
                      <td nowrap class="text-center align-middle" width="200">Empresa</td>
                      <td nowrap class="text-center align-middle" width="200">CNPJ;</td>
                      <td nowrap class="text-center align-middle" width="200">
                        &emsp; Status &emsp;
                      </td>
                      <td nowrap class="text-center align-middle" width="200">
                        &emsp; Produto &emsp;
                      </td>
                      <td nowrap class="text-center align-middle" width="50">Índice reajuste</td>
                      <td nowrap class="text-center align-middle" width="50">Início</td>
                      <td nowrap class="text-center align-middle" width="50">Término</td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1 || filters.product == 8"
                      >
                        Plano mensal
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Consultoria mensal
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Suporte 24x7
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Licenças
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Contatos Receptivos
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Números
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Ativos - único
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Ativos - campanha
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Ativos - SMS
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Auto Negociador
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Contatos + Envios de Ativos
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 1"
                      >
                        Atendimento / Protocolo
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 7"
                      >
                        Atendimento
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 7"
                      >
                        Contato/Agenda
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 7"
                      >
                        CPFs - Único
                      </td>

                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 8"
                      >
                        UAM
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle"
                        width="200"
                        v-if="!filters.product || filters.product == 8"
                      >
                        HSM
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{ inputNumberFilter: !data || data.length == 0 }"
                          v-model="filters.customer_id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.id"
                          v-bind:class="{ inputNumberFilter: !data || data.length == 0 }"
                        />
                      </td>
                      <td>
                        <SelectContractTypes
                          :first="'Todos'"
                          :selected="filters.contract_type"
                          @change="setFilter('contract_type', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{ inputTextFilter: !data || data.length == 0 }"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-bind:class="{ inputTextFilter: !data || data.length == 0 }"
                          v-model="filters.cnpj"
                        />
                      </td>
                      <td>
                        <SelectContractStatus
                          :selected="filters.status"
                          :first="'Todos'"
                          @change="setFilter('status', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td>
                        <SelectProducts
                          :selected="filters.product"
                          @change="setFilter('product', $event)"
                          class="form-control-sm"
                          :productsNotAppear="[2, 3, 4, 5, 6]"
                        />
                      </td>
                      <td>
                        <SelectContractReadjustmentIndex
                          :selected="filters.readjustmentIndex"
                          :first="'Todos'"
                          @change="setFilter('readjustmentIndex', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td></td>
                      <td>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input m-0"
                            type="checkbox"
                            id="expired"
                            v-model="filters.expired"
                          />
                          <label class="form-check-label form-control-sm" for="expired"
                            >Vencidos</label
                          >
                        </div>
                      </td>
                      <td
                        v-if="!filters.product || filters.product == 1 || filters.product == 7"
                      ></td>
                      <td
                        v-if="!filters.product || filters.product == 1 || filters.product == 8"
                      ></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 1"></td>
                      <td v-if="!filters.product || filters.product == 7"></td>
                      <td v-if="!filters.product || filters.product == 7"></td>
                      <td v-if="!filters.product || filters.product == 7"></td>
                      <td v-if="!filters.product || filters.product == 8"></td>
                      <td v-if="!filters.product || filters.product == 8"></td>
                    </tr>
                    <tr v-for="(contract, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ contract.customer.id }}</td>
                      <td class="text-center align-middle">{{ contract.id }}</td>
                      <td class="text-center align-middle">{{ contract.contract_type }}</td>
                      <td nowrap class="text-left align-middle">
                        {{ contract.customer.customerable.name }}
                      </td>
                      <td nowrap class="text-center align-middle">
                        {{ contract.customer.documents.value | cnpj | cpf }}
                      </td>
                      <td class="text-center align-middle">
                        {{
                          contract.status == 0
                            ? 'Suspenso'
                            : contract.status == 1
                            ? 'Bloqueado'
                            : 'Ativo'
                        }}
                      </td>
                      <td nowrap class="text-center align-middle">{{ contract.product.name }}</td>
                      <td nowrap class="text-center align-middle">{{ contract.readjustment_index ? contract.readjustment_index.index : '' }}</td>
                      <td class="text-center align-middle">{{ contract.start | date }}</td>
                      <td class="text-center align-middle">{{ contract.finish | date }}</td>
                      <td
                        class="text-center align-middle"
                        v-if="!filters.product || filters.product == 1 || filters.product == 8"
                      >
                        {{ contract.package }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.consulting }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.support24x7 }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.automatic_distribution }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.licence }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.contact }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.number }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.active_unique }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.active_campaign }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.active_sms }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.autonegotiator }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.contact_unified }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 1">
                        {{ contract.attendance_protocol }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 7">
                        {{ contract.chatbot_protocolo }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 7">
                        {{ contract.chatbot_agenda }}
                      </td>
                      <td class="align-middle" v-if="!filters.product || filters.product == 7">
                        {{ contract.chatbot_cpf_uniq }}
                      </td>

                      <td class="align-middle" v-if="!filters.product || filters.product == 8">
                        {{ contract.enterprise_contact }}
                      </td>

                      <td class="align-middle" v-if="!filters.product || filters.product == 8">
                        {{ contract.enterprise_active }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = 1">
                        <i class="fal fa-angle-double-left"></i>
                      </a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        <i class="fal fa-angle-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">{{
                        data.current_page - 2
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">{{
                        data.current_page - 1
                      }}</a>
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">{{ data.current_page }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">{{
                        data.current_page + 1
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 == data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">{{
                        data.current_page + 2
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        <i class="fal fa-angle-right"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page">
                        <i class="fal fa-angle-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showContractSave"
          @click="closeSaveContract()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomerContractModal from '@/components/contracts/CustomerContractModal';

import SelectProducts from '@/components/forms/SelectProducts';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import SelectContractStatus from '@/components/forms/SelectContractStatus';
import SelectContractTypes from '@/components/forms/SelectContractTypes';
import SelectContractReadjustmentIndex from '@/components/forms/SelectContractReadjustmentIndex';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportContractsAnalytical',
  props: ['start', 'finish'],
  components: { CustomerContractModal, SelectProducts, SelectContractStatus, SelectContractTypes, SelectContractReadjustmentIndex },
  data() {
    return {
      sortType: localStorage.customerContractsSortType
        ? localStorage.customerContractsSortType
        : 'id',
      sortReverse: localStorage.customerContractsSortReverse
        ? JSON.parse(localStorage.customerContractsSortReverse)
        : false,
      amount: localStorage.customerContractsDataAmount
        ? localStorage.customerContractsDataAmount
        : 100,
      page: localStorage.customerContractsDataPage ? localStorage.customerContractsDataPage : 1,
      filters: {
        id: localStorage.customerContractsFilterId ? localStorage.customerContractsFilterId : '',
        customer_id: localStorage.customerContractsFilterCustomer
          ? localStorage.customerContractsFilterCustomer
          : '',
        name: localStorage.customerContractsFilterName
          ? localStorage.customerContractsFilterName
          : '',
        cnpj: localStorage.customerContractsFilterCnpj
          ? localStorage.customerContractsFilterCnpj
          : '',
        status: localStorage.customerContractsFilterStatus
          ? localStorage.customerContractsFilterStatus
          : '',
        product: localStorage.customerContractsFilterProduct
          ? localStorage.customerContractsFilterProduct
          : '',
        contract_type: localStorage.customerContractsFilterContractType
          ? localStorage.customerContractsFilterContractType
          : '',
        expired: localStorage.customerContractsFilterExpired
          ? localStorage.customerContractsFilterExpired
          : false,
        readjustmentIndex: localStorage.customerContractsFilterReadjustmentIndex 
          ? localStorage.customerContractsFilterReadjustmentIndex
          : ''
      },
      data: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showContractSave() {
      return this.$store.state.showContractSave;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/report/customer/contract/analytical/download${this.convertFilters()}`;
      axios
        .get(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_contratos_analitico`;

          if (this.start) {
            fileName += `_${this.start}`;
          }

          fileName = `${fileName}.csv`;
          link.setAttribute('download', fileName);

          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.customer_id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.filters.status = '';
      this.filters.product = '';
      this.filters.contract_type = '';
      this.filters.sortType = 'customer_id';
      this.filters.sortReverse = false;
      this.filters.expired = false;
      this.filters.readjustmentIndex = '';
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerContractsFilterId', this.filters.id);
      localStorage.setItem('customerContractsFilterCustomer', this.filters.customer_id);
      localStorage.setItem('customerContractsFilterName', this.filters.name);
      localStorage.setItem('customerContractsFilterCnpj', this.filters.cnpj);
      localStorage.setItem('customerContractsFilterCnpj', this.filters.status);
      localStorage.setItem('customerContractsFilterProduct', this.filters.product);
      localStorage.setItem('customerContractsFilterContractType', this.filters.contract_type);
      localStorage.setItem('customerContractsDataAmount', this.amount);
      localStorage.setItem('customerContractsDataPage', this.page);
      localStorage.setItem('customerContractsSortType', this.sortType);
      localStorage.setItem('customerContractsSortReverse', this.sortReverse);
      localStorage.setItem('customerContractsFilterExpired', this.filters.expired);
      localStorage.setItem('customerContractsFilterReadjustmentIndex', this.filters.readjustmentIndex);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}
                        &id=${this.filters.id ? this.filters.id : ''}
                        &customer=${this.filters.customer_id ? this.filters.customer_id : ''}
                        &name=${this.filters.name ? this.filters.name : ''}
                        &cnpj=${this.filters.cnpj ? this.filters.cnpj : ''}
                        &status=${this.filters.status ? this.filters.status : ''}
                        &product=${this.filters.product ? this.filters.product : ''}
                        &contract_type=${
                          this.filters.contract_type ? this.filters.contract_type : ''
                        }
                        &amount=${this.amount}
                        &sortType=${this.sortType}
                        &sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}
                        &start=${this.start}
                        &end=${this.finish}
                        &expired=${this.filters.expired}
                        &readjustmentIndex=${this.filters.readjustmentIndex}`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/report/customer/contract/analytical${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        this.$emit('updateLoading');
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>

<style scoped>
.inputNumberFilter {
  width: 100px;
}

.inputTextFilter {
  width: 200px;
}
</style>
